export { SYSTEMS_NAMES as systemNames } from './enums';
export { default as Provider } from './DataProvider';

// helpers
export { default as AnalyticUtils } from './helpers/Utils';

// Create and export a singleton instance of Analytic
import Analytic from './Analytic';
export const Main = new Analytic();

export * from './Interfaces/Events';
export * from './Interfaces/DataProvider';
export * from './types';
export * from './enums';
